<template>
  <footer class="footer" :class="{ 'color-home': colorHome }">
    <img src="@/assets/img/eis.png" class="eis-logo-grey" alt="" />
    <v-container>
      <v-row>
        <v-col cols="12" md="5">
          <ul class="menu list-base">
            <li class="menu__title">
              Для обращений по вопросам пользования Личным кабинетом и
              совершения удаленных нотариальных действий:
            </li>
            <li class="menu__margin">
              <span class="desktop">Линия правовой помощи: </span>
              <a class="menu__link" href="tel:+78002343417">8 800 234 34 17</a>
            </li>
            <li class="menu__title">
              Портал для подачи сведений от органов местного самоуправления:
            </li>
            <li>
              <a :href="omsu">Портал подачи сведений от ОМСУ</a>
            </li>
          </ul>
        </v-col>
        <v-col cols="12" md="5">
          <ul class="menu list-base">
            <li class="menu__title">Федеральная нотариальная палата:</li>
            <li>
              <span class="menu__text"
                >127006, Москва, Долгоруковская, 15, стр. 4-5</span
              >
            </li>
            <li>
              <a class="menu__link" href="tel:+78002343417">8 800 234 34 17</a>
            </li>
            <li>
              <a class="menu__link" href="tel:+74959814366"
                >+7 (495) 981–43–66</a
              >
            </li>
            <li>
              <a class="menu__link" href="tel:+74959814367"
                >+7 (495) 981–43–67 (факс)</a
              >
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: ['colorHome'],
  data: function() {
    return {
      omsu: process.env.VUE_APP_OMSU_URL
    };
  }
};
</script>

<style scoped lang="scss">
.footer {
  background: $color-grey;
  padding: 115px 0;
  position: relative;
  overflow: hidden;

  &.color-home {
    background: white;
  }

  & .eis-logo-grey {
    right: 10%;

    @media screen and (max-width: $gr-md) {
      right: 0;
    }

    @media screen and (max-width: $gr-sm) {
      right: -177px;
    }
  }

  & .desktop {
    display: inline-block;
    @media screen and (max-width: $gr-md) {
      display: none;
    }
  }
}

.menu {
  display: flex;
  flex-direction: column;
  list-style: none;
  @media screen and (max-width: $gr-md) {
    margin-bottom: 30px;
  }

  li {
    padding-bottom: 5px;
    @media screen and (max-width: $gr-md) {
      padding-bottom: 0;
    }
  }
  
  &__margin {
    margin-bottom: 20px;
    @media screen and (max-width: $gr-md) {
      margin-bottom: 5px;
    }
  }

  &__title {
    color: $color-red;
    font-size: $font-size-middle-level-3;
    margin-bottom: 20px;
    font-weight: 500;

    @media screen and (max-width: $gr-md) {
      margin-bottom: 5px;
    }
  }

  &__link,
  &__text {
    color: $color-base;
    font-size: $font-size-small;
    text-decoration: none;
  }
}
</style>
